(function () {
    'use strict';

    angular.module("imApp").factory("salesProspectsService", ['$ihttp', function ($ihttp) {
        let service = {
            listSalesOpportunities: function (parms) {
                return $ihttp.post({
                    method: 1413,
                    parameters: parms || {}
                });
            },
            listSalesProspects: function (parms) {
                return $ihttp.post({
                    method: 1412,
                    parameters: parms || {}
                });
            },
            listCounts: function (parms) {
                return $ihttp.post({
                    method: 1411,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
